var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-dropper"},[_c('div',_vm._g({staticClass:"app-dropper__inner"},_vm.listeners),[_c('dropper-icon'),_c('span',{staticClass:"forMobile_or_p"},[_vm._v("Удалить")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }